import { Form } from "react-bootstrap";

import { monthOf, monthRange, recentMonths } from "utils/dateRange";
import { formatMonth } from "utils/dateFormat";

/**
 * "Give me one whole month" — the filter both order screens were being used to
 * approximate by hand.
 *
 * Sits next to the من/الى inputs rather than replacing them: an operator
 * narrowing down to a single evening still needs those. This exists because the
 * common case was a month, and doing it by hand got it wrong — a day picked in
 * "الى" carries 00:00, so "through 30/06" excluded the 30th and the page, its
 * totals and any statement raised from it were all short by a day.
 *
 * A PLAIN SELECT, not `<input type="month">`. The native control renders its
 * month name in the browser's own locale and left-to-right, and `lang="ar"`
 * does not change either — it showed "August 2026" in English, flush left,
 * among Arabic right-aligned filters. A select is Arabic, matches every other
 * control on this bar, and a month is a short enough list to just pick from.
 *
 * Writes BOTH bounds together, and clears both together, so the two fields can
 * never be left describing different intentions.
 *
 * @param {object} props
 * @param {URLSearchParams} props.searchParams - The page's live filter state.
 * @param {Function} props.setSearchParams
 * @param {Function} [props.onApplied] - Called after the range changes; the
 *   order pages use it to reset pagination to the first page.
 */
const MonthFilter = ({ searchParams, setSearchParams, onApplied }) => {
    const selected = monthOf(searchParams.get("startDate"), searchParams.get("endDate"));

    const options = recentMonths();
    // A bookmarked range older than the list still has to be selectable, or the
    // control would silently show "الكل" over a month that IS filtered.
    if (selected && !options.some((option) => option.value === selected)) {
        options.unshift({ value: selected, label: formatMonth(selected) });
    }

    const apply = (month) => {
        const range = month ? monthRange(month) : null;

        if (range) {
            searchParams.set("startDate", range.startDate);
            searchParams.set("endDate", range.endDate);
        } else {
            searchParams.delete("startDate");
            searchParams.delete("endDate");
        }

        setSearchParams(searchParams);
        onApplied?.();
    };

    return (
        <div className="col">
            <h6>شهر كامل</h6>
            <Form.Select value={selected} onChange={(event) => apply(event.target.value)}>
                <option value="">الكل</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
};

export default MonthFilter;
